module.exports = __webpack_public_path__ + "static/media/successIcon.6fcf661e.svg";